var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.608,
    height: 38.074,
    viewBox: "-10 -10 41.608 44.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 10,
    cy: 10,
    rx: 20,
    ry: 20,
    fill: "#EEBF78",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M23.108,22.166V19.777A4.777,4.777,0,0,0,18.331,15H8.777A4.777,4.777,0,0,0,4,19.777v2.389",
    transform: "translate(-4 -0.592)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 5.025,
    cy: 4.606,
    rx: 5.025,
    ry: 4.606,
    transform: "translate(4.507 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserYellow);
export default __webpack_public_path__ + "static/media/user_yellow.536a5e6aefcfe5bdb7eed10b043c107f.svg";
export { ForwardRef as ReactComponent };